export default __webpack_public_path__ + "static/media/lastStandSwitches.0cd5d1f4.jpg";